import { AxiosError } from "axios";
import { HttpErrorResponse } from "src/hooks/useAxios";
import { UNKNOWN_ERROR_MSG, notify, sendToSentry } from "src/utils";

export const handleBackendHttpError = (error: any) => {
    const axiosError = error as AxiosError;
    const httpError = axiosError?.response?.data as HttpErrorResponse;
    if (httpError) {
        // If we have a structured HttpError response
        if (httpError.userAlertMessage) {
            notify({
                level: httpError.userAlertLevel,
                title: httpError.userAlertTitle,
                message: httpError.userAlertMessage,
            });
            // Log to Sentry if needed
            if (httpError.logToSentry) {
                sendToSentry({ error: axiosError });
            }
        }
    } else if (axiosError?.response?.status >= 500) {
        // Handle generic 500 errors
        const message = UNKNOWN_ERROR_MSG;
        notify({
            level: "error",
            title: "Error",
            message,
        });
        sendToSentry({ error: axiosError });
    } else {
        // Handle other errors
        const message = axiosError?.message ?? "An unexpected error occurred";
        notify({
            level: "error",
            title: "Error",
            message,
        });
    }
};
